// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + ".legacy." + {"101":"e6af1d6ddfc78ccc722d","897":"d34063d08615b5675e20"}[chunkId] + ".js";
};